import { Stack } from '@mui/material'
import { GoBackButton } from '~/ui/components/GoBackButton'

export const FormWrapper = ({
  children,
  backRoute,
}: {
  children: React.ReactNode
  backRoute?: string
}) => {
  return (
    <Stack
      sx={{ mx: { xs: 0, sm: 'auto' }, minWidth: { xs: 1, sm: 600 }, gap: 2, overflow: 'hidden' }}
      height={1}
    >
      {backRoute ? <GoBackButton route={backRoute} /> : null}
      {children}
    </Stack>
  )
}
